/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  fill?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const CircleFilled = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 24 24"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <circle cx="12" cy="12" r="11" />
    </g>
  </svg>
);

export default CircleFilled;
